<template>
  <el-drawer
    :visible.sync="aDrawer"
    :direction="direction"
    :append-to-body="true"
    size="100%"
    custom-class="create-report-drawer"
  >
    <div class="create-report-drawer__content">
      <p class="create-report-drawer__title">
        {{$t('post.createReport.title')}}
      </p>

      <el-divider></el-divider>
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item :label="$t('post.createReport.form.key')">
          <el-input v-model="form.keyword"></el-input>
        </el-form-item>
        <el-form-item :label="$t('post.createReport.form.period')">
          <el-col :span="11">
            <el-date-picker type="date" format="dd.MM.yyyy" :placeholder="$t('post.createReport.form.placeholderFrom')" v-model="form.date_from" style="width: 100%;"></el-date-picker>
          </el-col>
          <el-col class="line" :span="2"></el-col>
          <el-col :span="11">
            <el-date-picker type="date" format="dd.MM.yyyy" :placeholder="$t('post.createReport.form.placeholderTo')" v-model="form.date_to" style="width: 100%;"></el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit" icon="el-icon-download" >{{$t('post.createReport.form.button')}}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-drawer>
</template>

<script>
  // library
  import moment from 'moment'

  export default {
    name: 'CreateReport',
    props: {
      reportDrawer: {
        type: Boolean
      }
    },
    data() {
      return {
        direction: 'rtl',
        form: {
          keyword: '',
          date_from: '',
          date_to: '',
        },
        link: `https://${!window.location.href.includes('test111') ? 'api' : 'apitest'}.glassen-it.com/component/socparser/stats/metareport`,
        format: "YYYY-MM-DD",
      };
    },
    computed: {
      aDrawer: {
        get() {
          return this.reportDrawer;
        },
        set() {
          this.$emit('openCreateReportWindow');
        },
      }
    },
    methods: {
      onSubmit() {
        let params = `?thread_id=${this.$route.params.threadId}&keyword=${this.form.keyword}&from=${moment(this.form.date_from).format(this.format)}&to=${moment(this.form.date_to).format(this.format)}`
        window.open(this.link+params, '_blank');
      }
    },
  };
</script>

<style>
  .create-report-drawer__content {
    height: inherit;
    padding: 20px;
  }

  .create-report-drawer__title {
    padding: 0;
    margin: 0;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 14px;
    color: #5E6D82;
  }
</style>
